import { render, staticRenderFns } from "./SelectedModelSidePanel.vue?vue&type=template&id=6d7f2354&scoped=true&"
import script from "./SelectedModelSidePanel.vue?vue&type=script&lang=js&"
export * from "./SelectedModelSidePanel.vue?vue&type=script&lang=js&"
import style0 from "./SelectedModelSidePanel.vue?vue&type=style&index=0&id=6d7f2354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7f2354",
  null
  
)

export default component.exports